<script>
import LetterIcon from './LetterIcon.vue';
import Icon from './Icon.vue';
import { Link } from '@inertiajs/vue3';
import DropdownMenuToggle from './DropdownMenuToggle.vue';
import DropdownCollapseToggle from './DropdownCollapseToggle.vue';
import { v4 as uuid } from 'uuid';

export default {
  components: {
    DropdownCollapseToggle,
    DropdownMenuToggle,
    Icon,
    LetterIcon,
    Link,
  },

  props: {
    class: {
      type: String,
      default: '',
    },

    route: {
      type: String,
      default: '',
    },

    parameters: {
      type: Object,
      default: {},
    },

    link: {
      type: String,
      default: '',
    },

    type: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    letter: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },

    component: {
      type: String,
      default: '',
    },

    show: {
      type: Boolean,
      default: true,
    },

    dropdown: {
      type: Boolean,
      default: false,
    },

    dropDownItems: {
      type: Object,
      default: {},
    },
    redirect: {
      type: Boolean,
      default: false,
    },
    blade: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      id: null,
      masterConfig: this.$page.props.master_config,
    };
  },

  computed: {
    url() {
      if (this.route != undefined && this.route !== '') {
        let parameters = this.parameters;
        parameters['shop_id'] = this.masterConfig?.shop_id;
        return route(this.route, parameters);
      }
      return this.link;
    },
  },

  created() {
    this.id = this.name.replace(/\W/g, '_');
  },

  methods: {
    dropdownLink(dropdown_item) {
      if (dropdown_item.route !== undefined) {
        return route(dropdown_item.route, {
          shop_id: this.masterConfig.shop_id,
        });
      }
      return dropdown_item.link;
    },
  },
};
</script>

<template>
  <DropdownCollapseToggle v-if="dropdown === true" :name="name" :icon="icon" :target="id" />

  <div v-if="dropdown === true" :id="id" class="collapse dropdown-collapse">
    <!-- Handle blade items in dropdown -->
    <a
      v-for="dropdownItem in dropDownItems.filter(
        (dropdownItem) => dropdownItem.external === false && dropdownItem.blade === true,
      )"
      class="dropdown-item"
      :href="dropdownLink(dropdownItem)"
    >
      <Icon v-if="dropdownItem.icon !== ''" :class-name="dropdownItem.icon" />
      {{ dropdownItem.name }}
    </a>

    <!-- Handle Inertia items in dropdown -->
    <Link
      v-for="dropdownItem in dropDownItems.filter(
        (dropdownItem) => dropdownItem.external === false && dropdownItem.blade !== true,
      )"
      class="dropdown-item"
      :href="dropdownLink(dropdownItem)"
    >
      <Icon v-if="dropdownItem.icon !== ''" :class-name="dropdownItem.icon" />
      {{ dropdownItem.name }}
    </Link>

    <!-- External links in dropdown -->
    <a
      v-for="dropdownItem in dropDownItems.filter((dropdownItem) => dropdownItem.external === true)"
      :href="dropdownItem.link"
      class="dropdown-item"
    >
      <Icon v-if="dropdownItem.icon !== ''" :class-name="dropdownItem.icon" />
      {{ dropdownItem.name }}
    </a>
  </div>

  <!-- Blade route (full page reload) -->
  <a
    v-if="show && route !== '' && dropdown === false && blade === true"
    :href="url"
    class="dropdown-item"
  >
    <div v-if="type === 'divider'" class="dropdown-divider" />
    <LetterIcon v-if="letter !== ''" :letter="letter" />
    <Icon v-if="icon !== ''" :class-name="icon" />
    {{ name }}
  </a>

  <!-- Inertia route with redirect prop -->
  <a
    v-else-if="show && route !== '' && dropdown === false && redirect === true && blade === false"
    :href="url"
    class="dropdown-item"
  >
    <div v-if="type === 'divider'" class="dropdown-divider" />
    <LetterIcon v-if="letter !== ''" :letter="letter" />
    <Icon v-if="icon !== ''" :class-name="icon" />
    {{ name }}
  </a>

  <!-- Inertia route (SPA navigation) -->
  <Link
    v-else-if="show && route !== '' && dropdown === false && redirect === false && blade === false"
    :href="url"
    class="dropdown-item"
  >
    <div v-if="type === 'divider'" class="dropdown-divider" />
    <LetterIcon v-if="letter !== ''" :letter="letter" />
    <Icon v-if="icon !== ''" :class-name="icon" />
    {{ name }}
  </Link>

  <!-- No route, just link -->
  <a
    v-else-if="show === true && route === '' && dropdown === false"
    :href="url || '#'"
    class="dropdown-item"
    :class="{ 'disable-link': !url }"
    @click="!url && $event.preventDefault()"
  >
    <div v-if="type === 'divider'" class="dropdown-divider" />
    <LetterIcon v-if="letter !== ''" :letter="letter" />
    <Icon v-if="icon !== ''" :class-name="icon" />
    {{ name }}
  </a>
</template>

<style scoped>
.disable-link {
  pointer-events: none;
  cursor: not-allowed;
  opacity: 0.6;
}
</style>
